// extracted by mini-css-extract-plugin
export default {"root":"Paywall_root__vZ+VB","fullHeight":"Paywall_fullHeight__9QJxw","loader":"Paywall_loader__vY2Be"};